import React from 'react';
import APP_DROPDOWNS from '../utils/ddlRegistry';
import { ModalTemplate } from './templates';
import './Modal.css';

/**
 * AssignDDLModal — read-only info modal.
 *
 * Shows which dropdown(s) a DDL collection is currently assigned to.
 * Assignment is now managed through the Register Dropdowns page.
 *
 * Props:
 *   collection – the DDL collection object
 *   onClose    – close handler
 */
export default function AssignDDLModal({ collection, onClose }) {
  const assignedTo = collection.assignedTo;
  const assignedIds = Array.isArray(assignedTo)
    ? assignedTo
    : assignedTo
    ? [assignedTo]
    : [];

  const assignedLabels = assignedIds
    .map((id) => APP_DROPDOWNS.find((d) => d.id === id)?.label || id)
    .filter(Boolean);

  return (
    <ModalTemplate
      title="Collection Info"
      onClose={onClose}
      actions={<button className="btn btn-secondary" onClick={onClose}>Close</button>}
    >
      <div className="form-group">
        <label>Collection</label>
        <div className="confirm-name-locked">
          <span className="confirm-name-value">{collection.name}</span>
        </div>
      </div>

      <div className="form-group">
        <label>Assigned to Dropdown(s)</label>
        {assignedLabels.length > 0 ? (
          <div className="assign-info-chips">
            {assignedLabels.map((label) => (
              <span key={label} className="assign-info-chip">{label}</span>
            ))}
          </div>
        ) : (
          <p className="assign-info-empty">
            Not assigned to any dropdown yet.
            Use <strong>Register Dropdowns</strong> to assign this collection.
          </p>
        )}
      </div>
    </ModalTemplate>
  );
}
